/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceConnectionStatus
 */
export interface WorkspaceConnectionStatus {
    /**
     * The status of the ticket.
     * @type {string}
     * @memberof WorkspaceConnectionStatus
     */
    status: WorkspaceConnectionStatusStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum WorkspaceConnectionStatusStatusEnum {
    Pending = 'PENDING',
    Approved = 'APPROVED',
    Confirmed = 'CONFIRMED',
    Rejected = 'REJECTED',
    Revoked = 'REVOKED',
    Expired = 'EXPIRED'
}

export function WorkspaceConnectionStatusFromJSON(json: any): WorkspaceConnectionStatus {
    return WorkspaceConnectionStatusFromJSONTyped(json, false);
}

export function WorkspaceConnectionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceConnectionStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function WorkspaceConnectionStatusToJSON(value?: WorkspaceConnectionStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}


